export default "__VITE_ASSET__BEfvAFvQ__"